import "./App.css";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import { Route, Routes } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import TopNav from "./components/navbar/TopNav";
import NavLinks from "./components/navbar/NavLinks";
import Apply from "./pages/Apply";
import Faq from "./pages/Faq";
import Teams from "./pages/Teams";
import Features from "./pages/Features";
import ImageGallery from "./pages/ImageGallery";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Message from "./components/Message";
import Ha from "./pages/Ha";
import Pharmacy from "./pages/Pharmacy";
import HaSubjects from "./pages/HaSubjects";
import PharmacySub from "./pages/PharmacySub";
import ScholarHA from "./pages/ScholarHA";
import ScholarDPH from "./pages/ScholarDPH";
import Events from "./pages/Events";
import Notices from "./pages/Notices";

function App() {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  return (
    <div>
      <TopNav />
      <NavLinks />
      <div className=" overflow-x-hidden overflow-y-hidden md:py-10  py-8 ">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/apply" element={<Apply />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/teams" element={<Teams />} />
          <Route path="/features" element={<Features />} />
          <Route path="/imageGallery" element={<ImageGallery />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/ha" element={<Ha />} />
          <Route path="/pharmacy" element={<Pharmacy />} />
          <Route path="/haSubjects" element={<HaSubjects />} />
          <Route path="/pharmacySub" element={<PharmacySub />} />
          <Route path="/scholarHA" element={<ScholarHA />} />
          <Route path="/ScholarDPH" element={<ScholarDPH />} />
          <Route path="/events" element={<Events />} />
          <Route path="/notices" element={<Notices />} />

        </Routes>
      </div>
      <Message />
      <Toaster />

      <Footer />
    </div>
  );
}

export default App;
